import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayGlobalIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12 0.25C5.52 0.25 0.25 5.52 0.25 12C0.25 18.48 5.52 23.75 12 23.75C18.48 23.75 23.75 18.48 23.75 12C23.75 5.52 18.48 0.25 12 0.25ZM8.23 12C8.23 10.92 8.29 9.91 8.41 8.96H15.61C15.72 9.91 15.79 10.92 15.79 12C15.79 13.08 15.73 14.09 15.61 15.04H8.41C8.3 14.09 8.23 13.08 8.23 12ZM16.86 8.96H21.78C22.08 9.92 22.25 10.94 22.25 12C22.25 13.06 22.08 14.08 21.78 15.04H16.86C16.97 14.08 17.02 13.06 17.02 12C17.02 10.94 16.96 9.92 16.86 8.96ZM21.3 7.71H16.69C16.31 5.36 15.62 3.42 14.72 2.13C17.64 2.94 20.04 5.01 21.3 7.71ZM12 1.62C13.33 1.62 14.77 3.98 15.42 7.7H8.58C9.23 3.98 10.67 1.62 12 1.62ZM9.28 2.13C8.38 3.42 7.69 5.36 7.31 7.71H2.7C3.96 5.01 6.36 2.94 9.28 2.13ZM2.22 8.96H7.14C7.03 9.92 6.98 10.94 6.98 12C6.98 13.06 7.04 14.08 7.14 15.04H2.22C1.92 14.08 1.75 13.06 1.75 12C1.75 10.94 1.92 9.92 2.22 8.96ZM2.7 16.29H7.31C7.69 18.64 8.38 20.58 9.28 21.87C6.36 21.06 3.96 18.99 2.7 16.29ZM12 22.38C10.67 22.38 9.23 20.02 8.58 16.3H15.42C14.77 20.02 13.33 22.38 12 22.38ZM14.72 21.87C15.62 20.58 16.31 18.64 16.69 16.29H21.3C20.04 18.99 17.64 21.06 14.72 21.87Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayGlobalIcon.displayName = 'PayGlobalIcon';
